import { useUpload } from './context'

export const Success = () => {
  const { state, handleReset } = useUpload()

  if (state.successRows === undefined) return null

  return (
    <div className="w-full rounded-md border border-gray-300 p-4 text-sm flex flex-col">
      <span className="font-bold">Results</span>
      {state.dryRun && state.successRows && state.successRows > 0 && (
        <>
          <span>
            Dry run complete: {state.successRows} rows would be successfully
            uploaded.
          </span>
          <button
            onClick={handleReset}
            className="mt-4 bg-blue-500 text-white rounded-md p-2 w-24"
          >
            Reset form
          </button>
        </>
      )}
      {!state.dryRun && (
        <div>
          {state.successRows && state.successRows > 1 && (
            <span>{state.successRows} rows were successfully uploaded</span>
          )}
          {state.successRows === 1 && (
            <span>One row was successfully uploaded</span>
          )}
        </div>
      )}
    </div>
  )
}
